import React from 'react';
import { Clock } from 'lucide-react';
import { Label } from '@/components/ui/label';
import { TimePickerInput } from '../ui/time-picker-input';

interface TimePickerDemoProps {
  date: Date | undefined;
  setDate: (date: Date | undefined) => void;
  hideLabel?: boolean;
  disabled?: boolean;
}

const TimePicker: React.FC<TimePickerDemoProps> = ({
  date,
  setDate,
  hideLabel,
  disabled,
}) => {
  const minuteRef = React.useRef<HTMLInputElement>(null);
  const hourRef = React.useRef<HTMLInputElement>(null);
  const secondRef = React.useRef<HTMLInputElement>(null);

  return (
    <div className="flex items-end gap-2">
      <div className="grid gap-1 text-center">
        {hideLabel ? null : (
          <Label htmlFor="hours" className="text-xs">
            Hours
          </Label>
        )}
        <TimePickerInput
          picker="hours"
          date={date}
          disabled={disabled}
          setDate={setDate}
          ref={hourRef}
          onRightFocus={() => minuteRef.current?.focus()}
        />
      </div>
      <div className="grid gap-1 text-center">
        {hideLabel ? null : (
          <Label htmlFor="minutes" className="text-xs">
            Minutes
          </Label>
        )}
        <TimePickerInput
          picker="minutes"
          date={date}
          disabled={disabled}
          setDate={setDate}
          ref={minuteRef}
          onLeftFocus={() => hourRef.current?.focus()}
          onRightFocus={() => secondRef.current?.focus()}
        />
      </div>
      <div className="grid gap-1 text-center">
        {hideLabel ? null : (
          <Label htmlFor="seconds" className="text-xs">
            Seconds
          </Label>
        )}
        <TimePickerInput
          picker="seconds"
          date={date}
          disabled={disabled}
          setDate={setDate}
          ref={secondRef}
          onLeftFocus={() => minuteRef.current?.focus()}
        />
      </div>
      <div className="flex h-10 items-center">
        <Clock className="ml-2 h-4 w-4" />
      </div>
    </div>
  );
};

export default TimePicker;
